import { useRef } from 'react';
// next
import NextLink from 'next/link';
// @mui
import { 
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import useCompany from '../../hooks/useCompany';
// routes
import { PATH_TIME, PATH_TODO, PATH_SALARY, PATH_RENEW, PATH_REVIEW, PATH_DASHBOARD } from '../../routes/paths';

// ----------------------------------------------------------------------

const hideScrollbar = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  overflowX: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export default function CrewPageTabs({ crewId, tab }) {
  const { crews } = useCompany();
  const crew = crews.find(crew => crew.id === parseInt(crewId)) || {};
  const { last_contract_renew = true, is_active = false, use_salary_claim = true } = crew;
  const renewRef = useRef(null);

  if (tab === 'renew') {
    renewRef?.current?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'smooth' });
  }

  return (
    <Stack direction="row" spacing={{ xs: 2, sm: 4 }} sx={{ ...hideScrollbar, py: 1 }}>
      {use_salary_claim ? (
      <NextLink
        href={`${PATH_DASHBOARD.root}?c=${crewId}`}
      >
        <TabItemStyle
          sx={{ minWidth: '75px' }}
          isActive={tab === 'dashboard'}
        >
          대시보드
        </TabItemStyle>
      </NextLink>
      ) : (null)}
      <NextLink
        href={`${PATH_TIME.root}?c=${crewId}`}
      >
        <TabItemStyle
          sx={{ minWidth: '60px' }}
          isActive={tab === 'time'}
        >
          출퇴근
        </TabItemStyle>
      </NextLink>
      <NextLink
        href={`${PATH_TODO.detail}?c=${crewId}`}
      >
        <TabItemStyle
          sx={{ minWidth: '100px' }}
          isActive={tab === 'todo'}
        >
          데일리 투두
        </TabItemStyle>
      </NextLink>
      <NextLink
        href={`${PATH_SALARY.approve}?c=${crewId}`}
      >
        <TabItemStyle
          sx={{ minWidth: '42px' }}
          isActive={tab === 'salary'}
        >
          급여
        </TabItemStyle>
      </NextLink>
      {is_active && (
        <NextLink
          href={`${PATH_RENEW.root}?c=${crewId}`}
        >
          <TabItemStyle
            ref={renewRef}
            sx={{ minWidth: '63px' }}
            isActive={tab === 'renew'}
          >
            재계약
          </TabItemStyle>
        </NextLink>
      )}
      {(last_contract_renew === false) && (  // null(미응답) 과 false(종료) 는 다름
        <NextLink
          href={`${PATH_REVIEW.detail}?c=${crewId}`}
        >
          <TabItemStyle
            sx={{ minWidth: '42px' }}
            isActive={tab === 'review'}
          >
            리뷰
          </TabItemStyle>
        </NextLink>
      )}
    </Stack>
  )
}

const TabItemStyle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ theme, isActive }) => {
  return {
    ...theme.typography.h4,
    color: theme.palette.text.disabled,
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
    },
    ...(isActive && {
      color: theme.palette.text.primary,
    })
  }
});